import React from 'react';
import { useLifeIssuerBuild } from './useLifeIssuerBuild';
import { IssuerCoverageBuilder } from 'src/features/issuerCoverageBuilder/IssuerCoverageBuilder';

export const LifePlans = () => {
  const { build } = useLifeIssuerBuild();

  return <IssuerCoverageBuilder build={build} />;
};
